import { Container, Row, Col } from "react-bootstrap";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle,FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import classes from "./Packages.module.scss"
import { useEffect, useState } from "react";
import TagIcon from '@mui/icons-material/Tag';

const PackageSelectRow = ({amounts=null, onPaymentTypeChange : onPaymentTypeChangeCb, onPayTypeChange : onPayTypeChangeCb, onAmountChange: onAmountChangeCb}) => {
    const [paymentType, setPaymentType] = useState("Invoice");
    const [payType, setPayType] = useState("Monthly");
    const [amount, setAmount] = useState();
    const [quant, setQuant] = useState([]);
    //console.log(quant);
    useEffect(() => {
        setQuant(amounts);
        if(amounts && amounts.length>0){
            setAmount(amounts[0].value)
            if(onAmountChangeCb)
                onAmountChangeCb(amounts[0].value);
        }
            
    },[amounts])

    const onAmountChange = (e) =>{
        setAmount(e.target.value);
        if(onAmountChangeCb)
            onAmountChangeCb(e.target.value);
    }
    const onPaymentTypeChange = (e) =>{
        setPaymentType(e.target.value);
        if(onPaymentTypeChangeCb)
            onPaymentTypeChangeCb(e.target.value);
    }

    const onPayTypeChange = (e) =>{
        setPayType(e.target.value);
        if(onPayTypeChangeCb)
            onPayTypeChangeCb(e.target.value);
    }

    return(
        <Row className={classes["pay-prefilters"]}>
            <Col className = {(quant && quant.length>0) ? "col-12 mt-2 mt-lg-0 col-lg-4" : "col-12 mt-2 mt-lg-0 col-lg-6"}>
                <FormControl fullWidth>
                    <InputLabel id={"payment-type"}>Payment type</InputLabel>
                    <Select
                        labelId={"payment-type"}
                        id={"payment-type-select"}
                        value={paymentType}
                        label="Payment type"
                        onChange={onPaymentTypeChange}
                    >
                        <MenuItem value={"Invoice"}><ReceiptIcon className={classes["pay-icons"]}/>Invoice</MenuItem>
                        <MenuItem value={"PayPal/BankCard"}><CreditCardIcon className={classes["pay-icons"]}/>Paypal/Bank card</MenuItem>
                    </Select>
                </FormControl>
            </Col>
            <Col className = {(quant && quant.length>0) ? "col-12 mt-2 mt-lg-0 col-lg-4" : "col-12 mt-2 mt-lg-0 col-lg-6"}>
                <FormControl fullWidth>
                    <InputLabel id={"pay-type"}>Type</InputLabel>
                    <Select
                        labelId={"pay-type"}
                        id={"pay-type-select"}
                        value={payType}
                        label="Pay type"
                        onChange={onPayTypeChange}
                    >
                        <MenuItem value={"Monthly"}><TodayIcon className={classes["pay-icons"]}/>Monthly</MenuItem>
                        <MenuItem value={"Yearly"}><CalendarMonthIcon className={classes["pay-icons"]}/>Yearly</MenuItem>
                    </Select>
                </FormControl>
            </Col>
            {quant && quant.length>0 && 
                <Col className = "col-12 mt-2 mt-lg-0 col-lg-4">
                    <FormControl fullWidth>
                        <InputLabel id={"amount"}>Amount</InputLabel>
                        <Select
                            labelId={"amount"}
                            id={"amount-select"}
                            value={amount}
                            label="Amount"
                            onChange={onAmountChange}
                        >
                            {quant.map(item => {
                                return <MenuItem value={item.value}><TagIcon className={classes["pay-icons"]}/>{item.title}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Col>
            }
        </Row>
    )
}

export default PackageSelectRow;